module.exports = __webpack_public_path__ + "assets/img/45d9b0bba38655249422a9ebb830bd40.svg";